import toastr from "toastr"
import "toastr/build/toastr.min.css"
export const showMessage = (messageType, data) => {
  if (messageType === "success") toastr.success(data)
  else if (messageType === "error") toastr.error(data)
}
